// Not exported: nothing outside this module needs the photo shape by name,
// only the `photos` prop it shapes (fallow's dead-code check flags an
// exported type with no importer).
interface MasonryPhoto {
  src: string;
  alt: string;
}

interface MasonryProps {
  photos: readonly MasonryPhoto[];
  /** `trigger` is the clicked thumbnail, so the caller can restore focus to it. */
  onOpen: (index: number, trigger: HTMLButtonElement) => void;
}

/**
 * Responsive CSS-columns masonry: 2 columns on mobile, 3-4 on desktop.
 * Every tile is a real `<button>` (not a `<div onClick>`) so it is
 * keyboard-focusable and reachable by screen readers; each opens the
 * `Lightbox` at its own index.
 */
export function Masonry({ photos, onOpen }: MasonryProps) {
  return (
    <div className="columns-2 gap-3 sm:columns-3 lg:columns-4">
      {photos.map((photo, index) => (
        <button
          key={photo.src + index.toString()}
          type="button"
          onClick={(e) => onOpen(index, e.currentTarget)}
          className="group mb-3 block w-full break-inside-avoid overflow-hidden rounded-2xl border border-hairline bg-card transition duration-300 hover:shadow-lift focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-deep"
          aria-label={`Open photo ${index + 1} of ${photos.length}: ${photo.alt}`}
        >
          <img
            src={photo.src}
            alt={photo.alt}
            loading="lazy"
            className="w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
          />
        </button>
      ))}
    </div>
  );
}
